import React, { useState, useMemo } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import SideMenu from '../navbar/SideMenu';
import SideMenuBuhumuza from '../navbar/SideMenuGitega'; 
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  TextField,
  List, 
  ListItem, 
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Stack
} from '@mui/material';

import {
  ExpandLess,
  Search,
  Menu as MenuIcon,
  ExpandMore,
  LocationOn,
  TrendingUp,
  TrendingDown,
  Group
} from '@mui/icons-material';

const drawerWidth = 240;
const rightDrawerWidth = 280; 
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const RightDrawerWrapper = styled('div')(({ theme }) => ({
  width: rightDrawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    right: 0,
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(100%)',
    },
  }
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ZoneRow = styled(TableRow)({
  backgroundColor: '#f8f8f8',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#e8e8e8 !important'
  }
});

const cankuzoData = {
  title: "REPARTITION DE LA POPULATION DES MENAGES ORDINAIRES PAR COLLINE, ZONE ET COMMUNE (RESULTATS PRELIMINAIRES)",
  province: {
    id: "1",
    name: "CANKUZO",
    commune: {
      id: "101",
      name: "CANKUZO",
      total: 158274,
      zones: [
        {
          id: "10101",
          name: "PARK NATIONAL D",
          total: 0,
          collines: [
            { id: "10101101", name: "PARK NATIONAL DE LA RUVUBU", population: 0 }
          ]
        },
        {
          id: "10102",
          name: "CANKUZO",
          total: 70891,
          collines: [
            { id: "10102101", name: "CANKUZO", population: 11300 },
            { id: "10102102", name: "MUYAGA", population: 2554 },
            { id: "10102103", name: "MUTERERO", population: 3238 },
            { id: "10102104", name: "KAVUMU", population: 23693 },
            { id: "10102105", name: "MUHWEZA", population: 5654 },
            { id: "10102106", name: "NYABISINDU", population: 4456 },
            { id: "10102107", name: "GATUNGURWE", population: 3585 },
            { id: "10102108", name: "MUGOZI", population: 3694 },
            { id: "10102109", name: "KABUGA", population: 2722 },
            { id: "10102110", name: "MUSENYI", population: 2905 },
            { id: "10102111", name: "KABEZA", population: 2458 },
            { id: "10102112", name: "NYAMUSENGA", population: 1819 },
            { id: "10102113", name: "MUGENDA", population: 1028 },
            { id: "10102114", name: "MUGONGO", population: 761 },
            { id: "10102115", name: "NYAKIVUMU", population: 1024 }
          ]
        },
        {
          id: "10103",
          name: "GITANGA",
          total: 31731,
          collines: [
            { id: "10103101", name: "GITANGA", population: 5851 },
            { id: "10103102", name: "RUJUNGU", population: 4505 },
            { id: "10103103", name: "SASWE", population: 4122 },
            { id: "10103104", name: "KIBUNGO", population: 4496 },
            { id: "10103105", name: "KIGAGA", population: 4050 },
            { id: "10103106", name: "SHINGE", population: 2818 },
            { id: "10103107", name: "NYAMATONGO", population: 2464 },
            { id: "10103108", name: "MASHIGA", population: 3425 }
          ]
        },
        {
          id: "10104",
          name: "KIGAMBA",
          total: 36499,
          collines: [
            { id: "10104101", name: "RUSAGARA", population: 7603 },
            { id: "10104102", name: "KAZIBAZIBA", population: 4108 },
            { id: "10104103", name: "NYARURAMBI", population: 4143 },
            { id: "10104104", name: "RWAMVURA", population: 3316 },
            { id: "10104105", name: "GATUNGURU", population: 3420 },
            { id: "10104106", name: "GISENGA", population: 3152 },
            { id: "10104107", name: "HUMURE", population: 4269 },
            { id: "10104108", name: "KIGAMBA", population: 3725 },
            { id: "10104109", name: "KIVUMU", population: 2757 },
            { id: "10104110", name: "CHAMP DE TIR", population: 6 }
          ]
        },
        {
          id: "10105",
          name: "MINYARE",
          total: 19153,
          collines: [
            { id: "10105101", name: "MUREHE", population: 5979 },
            { id: "10105102", name: "RUTOKE", population: 5070 },
            { id: "10105103", name: "NYARUTITI", population: 4130 },
            { id: "10105104", name: "CHAMP DE TIR", population: 0 },
            { id: "10105105", name: "NYAKERERA", population: 2051 },
            { id: "10105106", name: "KARAGO", population: 1923 }
          ]
        }
      ]
    }
  }
};

const PopulationDataPageBuhumuzaCankuzo = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileRightOpen, setMobileRightOpen] = useState(false);
  const [expandedZones, setExpandedZones] = useState({});
  const [openKeyStats, setOpenKeyStats] = useState(true);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleRightDrawerToggle = () => {
    setMobileRightOpen(!mobileRightOpen);
  };

  const toggleZone = (zoneId) => {
    setExpandedZones(prev => ({
      ...prev,
      [zoneId]: !prev[zoneId]
    }));
  };

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data;
    
    const filteredZones = data.province.commune.zones.map(zone => {
      const filteredCollines = zone.collines.filter(colline =>
        colline.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
      return {
        ...zone,
        collines: filteredCollines,
        show: filteredCollines.length > 0 || 
              zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      };
    }).filter(zone => zone.show || !searchTerm);
    
    return {
      ...data,
      province: {
        ...data.province,
        commune: {
          ...data.province.commune,
          zones: filteredZones
        }
      }
    };
  };

  const filteredData = filterData(cankuzoData, searchTerm);

  const keyStats = useMemo(() => {
    const commune = cankuzoData.province.commune;
    
    const mostPopulatedZone = commune.zones.reduce((max, zone) => 
      zone.total > max.total ? zone : max, commune.zones[0]);
    
    const leastPopulatedZone = commune.zones.reduce((min, zone) => 
      zone.total < min.total ? zone : min, commune.zones[0]);
    
    const mostPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((max, colline) => colline.population > max.population ? colline : max, commune.zones[0].collines[0]);
    
    const leastPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .filter(colline => colline.population > 0) // Exclure les collines avec 0 population
      .reduce((min, colline) => colline.population < min.population ? colline : min, commune.zones[0].collines[0]);

    const zonePercentages = commune.zones.map(zone => ({
      ...zone,
      percentage: ((zone.total / commune.total) * 100).toFixed(1)
    }));
    
    return {
      totalPopulation: commune.total.toLocaleString(),
      totalZones: commune.zones.length,
      totalCollines: commune.zones.reduce((sum, zone) => sum + zone.collines.length, 0),
      mostPopulatedZone,
      leastPopulatedZone,
      mostPopulatedColline,
      leastPopulatedColline,
      zonePercentages,
      communeTotal: commune.total
    };
  }, []);

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            <SideMenu /> 
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            <SideMenu />
          </Drawer>
        )}

       
        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
                <Button 
                  variant="outlined" 
                  endIcon={<MenuIcon />} 
                  onClick={handleRightDrawerToggle}
                  sx={{ color: secondaryColor, borderColor: secondaryColor }}
                >
                  Info CANKUZO
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="body1" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {cankuzoData.title}
                    </Typography>
                    <Chip 
                      icon={<Group />} 
                      label={`Commune de CANKUZO`} 
                      color="primary" 
                      variant="outlined" 
                    />
                  </Box>
                  
                  <Grid container spacing={1} style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6}></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher zone/colline..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '400px' } }}
                      />
                    </Grid>
                  </Grid>
                
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                         Commune de CANKUZO
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Population Totale
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="primary">
                                {keyStats.totalPopulation}
                              </Typography>
                              <Typography variant="caption">
                                Habitants
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Zones
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="secondary">
                                {keyStats.totalZones}
                              </Typography>
                              <Typography variant="caption">
                                Zones répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Collines
                              </Typography>
                              <Typography variant="h4" fontWeight="bold">
                                {keyStats.totalCollines}
                              </Typography>
                              <Typography variant="caption">
                                Collines répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.mostPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.leastPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.leastPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.mostPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.leastPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>

                     
                      <Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                          Répartition de la population par zone
                        </Typography>
                        {keyStats.zonePercentages.map((zone) => (
                          <Box key={zone.id} sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                              <Typography variant="body2">
                                {zone.name}
                              </Typography>
                              <Typography variant="body2" fontWeight="bold">
                                {zone.percentage}% ({zone.total.toLocaleString()})
                              </Typography>
                            </Box>
                            <LinearProgress 
                              variant="determinate" 
                              value={zone.percentage} 
                              sx={{ 
                                height: 8, 
                                borderRadius: 4,
                                backgroundColor: '#e0e0e0',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: zone.id === keyStats.mostPopulatedZone.id ? primaryColor : 
                                                zone.id === keyStats.leastPopulatedZone.id ? secondaryColor : '#888',
                                }
                              }} 
                            />
                          </Box>
                        ))}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Zone/Colline</TableCell>
                          <TableCell align="right">Population</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {filteredData.province.commune.zones.map((zone) => (
                          <React.Fragment key={zone.id}>
                            <ZoneRow 
                              hover 
                              onClick={() => toggleZone(zone.id)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row" colSpan={2}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedZones[zone.id] ? <ExpandLess /> : <ExpandMore />}
                                  <LocationOn sx={{ mr: 1, color: primaryColor }} />
                                  {zone.name}
                                </Box>
                              </TableCell>
                            </ZoneRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={2}>
                                <Collapse in={expandedZones[zone.id] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {zone.collines.map((colline) => (
                                        <TableRow key={colline.id} hover>
                                          <TableCell sx={{ pl: 4 }}>{colline.name}</TableCell>
                                          <TableCell align="right">{colline.population.toLocaleString()}</TableCell>
                                        </TableRow>
                                      ))}
                                      <TableRow>
                                        <TableCell sx={{ pl: 4, fontWeight: 'bold' }}>Total {zone.name}</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>{zone.total.toLocaleString()}</TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                        <TableRow sx={{ backgroundColor: '#e0e0e0', fontWeight: 'bold' }}>
                          <TableCell>TOTAL COMMUNE DE CANKUZO</TableCell>
                          <TableCell align="right">{cankuzoData.province.commune.total.toLocaleString()}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                </Paper>
                
               
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      Structure administrative - Commune de CANKUZO
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      La commune de CANKUZO est divisée en {keyStats.totalZones} zones administratives:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      {keyStats.zonePercentages.map((zone, index) => (
                        <ListItem key={zone.id}>
                          <ListItemText 
                            primary={`${index + 1}. ${zone.name}`} 
                            secondary={`Population: ${zone.total.toLocaleString()} habitants (${zone.percentage}%) - ${zone.collines.length} collines`} 
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
                
              
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population. 
                    Les chiffres incluent uniquement la population des ménages ordinaires.
                    Les pourcentages sont calculés par rapport à la population totale de la commune de CANKUZO ({keyStats.totalPopulation} habitants).
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>

        
        {!isMobile ? (
          <RightDrawerWrapper>
            <SideMenuBuhumuza />
          </RightDrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            anchor="right"
            open={mobileRightOpen}
            onClose={handleRightDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: rightDrawerWidth },
            }}
          >
            <SideMenuBuhumuza /> 
          </Drawer>
        )}
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default PopulationDataPageBuhumuzaCankuzo;